module.exports = __webpack_public_path__ + "static/media/image (8).57fa0a48.jpg";